module.exports = __webpack_public_path__ + "img/notviewicon.f83479fd.svg";